<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label()">{{ label() }}</mat-label>
    <mat-select
        [required]="required() && !internalValue()"
        [panelClass]="isRTLLikeString"
        [formControl]="internalFormControl"
        [placeholder]="label() || placeholder()"
        [(value)]="internalValue"
        (selectionChange)="valueChanged()"
        (openedChange)="openedChanged($event)">
        <mat-form-field
            *ngIf="shouldHaveFilter()"
            subscriptSizing="dynamic"
            appearance="fill">
            <input
                #searchBox
                type="text"
                matInput
                st-click-stop-propagation
                [placeholder]="searchLabel()"
                [formControl]="comboBoxFilter"
                (keydown.escape)="onEscClick()" />
        </mat-form-field>
        <mat-option *ngIf="addEmptyOption()">{{ emptyLabel() }}</mat-option>
        <ng-template [ngIf]="addSeparatorAfterEmptyOption()">
            <mat-divider />
        </ng-template>
        <mat-option
            *ngFor="let item of filteredOptions | async"
            [value]="item?.id">
            {{ item?.title }}
        </mat-option>
        <ng-template [ngIf]="itemList() && additionalItemList().length > 0">
            <mat-divider />
        </ng-template>
        <mat-option
            *ngFor="let item of filteredTimeZoneOptions | async"
            [value]="item?.id">
            {{ item?.title }}
        </mat-option>
    </mat-select>
    <mat-hint *ngIf="hint()"> {{ hint() }} </mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
